import { Routes, Route } from 'react-router-dom'
import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@hooks/graphql'
import { gql } from 'graphql-request'

import Breadcrumbs from '@components/Breadcrumbs'
import Spinner from '@components/Spinner'
import ConsentFlow from './ConsentFlow'
import ClassroomBlocked from './ClassroomBlocked'

const CLASSROOM_QUERY = gql`
  query classroom($id: ID!) {
    classroom(id: $id) {
      id
      name
      research
      researchConsentingOnly
      researchMotivationDocument {
        url
        filename
      }
      classroomEnrollment {
        researchConsent
      }
    }
  }
`

const ClassroomResearchConsent = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { isLoading, data: { classroom = {} } = {} } = useQuery({
    queryKey: ['classroom-research-consent', id],
    gqlQuery: CLASSROOM_QUERY,
    variables: { id },
    onSuccess: data => {
      if (data.classroom.classroomEnrollment.researchConsent === true) {
        navigate(`/students/classrooms/${id}`, { replace: true })
      } else if (data.classroom.classroomEnrollment.researchConsent === false && data.classroom.researchConsentingOnly) {
        navigate(`/students/classrooms/${id}/research-consent/blocked`, { replace: true })
      }
    }
  })

  if (isLoading) {
    return <Spinner className='relative left-0 top-0 flex h-screen w-full items-center justify-center' />
  }

  return (
    <>
      <Breadcrumbs>
        <Breadcrumbs.Link label='Classrooms' to='/students/classrooms' />
        <Breadcrumbs.Text label={classroom.name} />
      </Breadcrumbs>

      <Routes>
        <Route index element={<ConsentFlow classroom={classroom} />} />
        <Route path='/blocked' element={<ClassroomBlocked />} />
      </Routes>
    </>
  )
}

export default ClassroomResearchConsent
